import { TableCell, styled, tableCellClasses } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '16px 14px',
  border: 'none',

  // Fixes the svg icon size of the checkbox because the eds checkbox component uses rem units for its fontSize
  '.MuiCheckbox-root': {
    '.MuiSvgIcon-root': {
      fontSize: '24px',
    }
  },

  [`&.${tableCellClasses.head}`]: {
    fontWeight: "normal",
    fontSize: theme.typography.body1.fontSize,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: theme.typography.body1.fontSize,

    [`&:empty:before`]: {
      content: '"-"',
    },
  },
}));
